import * as React from 'react';
import Script from './Script';

export type Props = {
  fonts: Array<Record<any, any>>;
  typeKitId: string | null | undefined;
};
const TypeKitFontsScript = ({fonts, typeKitId}: Props) => {
  if (typeKitId && fonts.length > 0) {
    const typeKitSrc = `https://use.typekit.net/${typeKitId}.js`;
    return (
      <Script
        src={typeKitSrc}
        onLoad={(window) => {
          window.Typekit && window.Typekit.load({async: true});
        }}
      />
    );
  }
  return null;
};

export default React.memo(TypeKitFontsScript) as React.ComponentType<Props>;
